var OCS = OCS || {};
OCS.Live = OCS.Live || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.StorageManager = new Class({
    Implements: [Options, Events],
    class_name: "StorageManager",
    manager_name: 'StorageManager',
    web_storage_stores: {},
    web_storage_status: {},
    clear_storage_timeout: null,
    options: {
        debug: false,
        manager_name: 'storage_manager',
        storage_prefix: 'ocs::',
        meta_storage_key: 'meta_info',
        meta_storage_type: 'js',
        storage_test_obj: {'to_be_removed': true},
        storage_test_key: 'test_obj',
        session_storage_type_string: 'session',
        local_storage_type_string: 'local',
        js_storage_type_string: 'js',
        default_storage_type: 'local',
        allow_session_storage: true,
        allow_local_storage: true,
        data_expiration_event: "data_expired",
        time_resolution: 100000,
        expiration_offset: {
            local: 1 * 15 * 60 * 1000, // 15 minutes
            session: 1 * 15 * 60 * 1000, // 15 minutes,
            js: 1 * 70 * 60 * 1000 // 70 minutes
        },
        never_expire: false
    },
    initialize: function (op) {
        if (OCS.Live[this.manager_name]) {
            return OCS.Live[this.manager_name];
        }
        OCS.Live[this.manager_name] = this;
        this.setOptions(op);
        this.check_web_storage_stores();
        this.initialize_meta_info();

        // Register the events
        this.initialize_events();
        this.deep_clean_storage();
    },
    initialize_events: function () {
        this.addEvent('clear_storage', this.on_clear_storage.bind(this));
        this.addEvent('cleanup', this.deep_clean_storage.bind(this));
    },
    initialize_meta_info: function () {
        var meta_info = {};
        if (this.web_storage_status[this.options.local_storage_type_string]) {
            meta_info[this.options.local_storage_type_string] = {};
        }
        if (this.web_storage_status[this.options.session_storage_type_string]) {
            meta_info[this.options.session_storage_type_string] = {};
        }

        meta_info[this.options.js_storage_type_string] = {};
        this.build_meta_info(meta_info);
        this.web_storage_stores[this.options.meta_storage_type].setItem(this.options.meta_storage_key, meta_info);
        return meta_info;
    },

    /* Actions */
    build_meta_info: function (meta_info) {
        var j, j_len;
        var meta_keys = Object.keys(meta_info);
        for (j = 0, j_len = meta_keys.length; j < j_len; j++) {
            this.build_meta_info_type(meta_info, meta_keys[j]);
        }
        return meta_info;
    },
    build_meta_info_type: function (meta_info, storage_type) {
        var i, i_len, data, data_metadata, original_key;
        if (this.web_storage_stores[storage_type] && this.web_storage_stores[storage_type].length) {
            for (i = 0, i_len = this.web_storage_stores[storage_type].length; i < i_len; ++i) {
                data_metadata = {};
                original_key = String(this.web_storage_stores[storage_type].key(i));
                if (!original_key.contains(this.options.storage_prefix)) {
                    // We don't know what this is, since it does not match our key. So lets get rid of it
                    this.remove_store_key(original_key, storage_type);
                    continue;
                }
                data = this.storage_retrieve(storage_type, original_key);
                if (data && data.t) {
                    data_metadata.t = data.t * this.options.time_resolution;
                }
                if (!meta_info[storage_type]) {
                    meta_info[storage_type] = {};
                }
                meta_info[storage_type][original_key] = data_metadata;
            }
        }
    },
    check_web_storage_stores: function () {
        this.web_storage_stores[this.options.js_storage_type_string] = new OCS.Classes.JSStorage();
        this.web_storage_status[this.options.session_storage_type_string] = false;
        this.web_storage_status[this.options.local_storage_type_string] = false;
        this.web_storage_status[this.options.js_storage_type_string] = true;
        if (this.check_web_storage_type(this.options.local_storage_type_string)) {
            this.web_storage_stores[this.options.local_storage_type_string] = window.localStorage;
            this.web_storage_status[this.options.local_storage_type_string] = true;
        }
        if (this.check_web_storage_type(this.options.session_storage_type_string)) {
            this.web_storage_stores[this.options.session_storage_type_string] = window.sessionStorage;
            this.web_storage_status[this.options.session_storage_type_string] = true;
        }
        if (!this.web_storage_status[this.options.local_storage_type_string] || !this.web_storage_status[this.options.default_storage_type]) {
            if (this.web_storage_status[this.options.session_storage_type_string]) {
                this.options.default_storage_type = this.options.session_storage_type_string;
            } else {
                this.options.default_storage_type = this.options.js_storage_type_string;
            }
        }
    },
    cleanup_store: function (type, options) {
        var meta_key, meta_data, removed, meta_info;
        var retry = false;
        var removed_titles = [];

        var dateObj = new OCS.Classes.OCSDateTime();
        var cleaning_time = dateObj.get_server_epoch_time();

        if (options && options.deep_clean) {
            meta_info = this.initialize_meta_info();
            if (!meta_info[type]) {
                this.build_meta_info_type(meta_info, type);
            }
        } else {
            meta_info = this.get_meta_info();
        }

        if (meta_info[type]) {

            // Loop through each key in the storage
            var storage_meta_keys = Object.keys(meta_info[type]);
            for (var i = 0, len = storage_meta_keys.length; i < len; ++i) {
                removed = false;
                meta_key = storage_meta_keys[i];
                if (meta_key) {
                    meta_data = meta_info[type][meta_key];
                    var product_time = meta_data.t;
                    if (product_time && this.is_time_expired(product_time, type, cleaning_time)) {
                        this.data_expired(cleaning_time, this.storage_retrieve(type, meta_key), meta_key);
                        this.clear_store_key(meta_key, type);
                        removed = true;
                    }
                    if (this.options.deep_clean && !product_time) {
                        this.clear_store_key(meta_key, type);
                        removed = true;
                    }
                    if (removed) {
                        retry = true;
                        removed_titles.push(meta_key);
                    }
                }
            }
        }
        if (retry) {
            console.debug('storage_manager: Cleanup successful. Restoring access to ' + type + ' storage. ' + removed_titles.length + ' items removed.');
            if (removed_titles.length) {
                console.debug('storage_manager: ' + removed_titles.join());
            }
            this.web_storage_status[type] = this.check_web_storage_type(type);
        }
    },
    clear_storage: function () {
        if (!this.clear_storage_timeout) {
            this.clear_storage_timeout = setTimeout(function () {
                this.on_clear_storage();
            }.bind(this), 0);
        }
    },    
    clear_store_key: function (in_key, type) {
        this.remove_store_key(in_key, type);
        this.update_meta_info(in_key, type, {remove: true});
        return true;
    },
    deep_clean_storage: function () {
        this.cleanup_store(this.options.session_storage_type_string, {deep_clean: true});
        this.cleanup_store(this.options.local_storage_type_string, {deep_clean: true});
        this.cleanup_store(this.options.js_storage_type_string, {deep_clean: true});
    },

    prepare_json_value: function (value, type, options) {
        var dateObj = new OCS.Classes.OCSDateTime();
        var time;
        if (options && options.timestamp_epoch) {
            time = this.prepare_json_time_value(options.timestamp_epoch);
        } else {
            time = this.prepare_json_time_value(dateObj.get_server_epoch_time());
        }

        var obj = {t: time, v: value};
        if (type === this.options.js_storage_type_string) {
            return obj;
        }
        return JSON.stringify(obj);
    },
    prepare_json_time_value: function (time) {
        return Math.floor(time / this.options.time_resolution);
    },
    prepare_key: function (key) {
        return this.options.storage_prefix + this.remove_prefix_from_key(key);
    },
    remove_store_key: function (in_key, type) {
        if (this.web_storage_stores[type]) {
            this.web_storage_stores[type].setItem(in_key, null);
            this.web_storage_stores[type].removeItem(in_key);
        }
    },
    remove_prefix_from_key: function (in_key) {
        if (in_key) {
            return in_key.replace(this.options.storage_prefix, '');
        }
    },
    retrieve: function (in_key, in_type) {
        var response, json_obj, type;
        var key = this.prepare_key(in_key);
        var dateObj = new OCS.Classes.OCSDateTime();
        var retrieval_time = dateObj.get_server_epoch_time();

        if (!in_type) {
            type = this.get_meta_info_key_type(key);
        } else {
            type = in_type;
        }

        if (this.web_storage_stores[type]) {
            json_obj = this.storage_retrieve(type, key);
            response = this.get_value_from_json(json_obj);

            // If the data is expired, remove it
            if (json_obj && json_obj.t) {
                // Test that the product has not expired, and in case we are in data review mode, the data is not later than our current time.
                if (this.is_time_expired(parseInt(json_obj.t * this.options.time_resolution), type, retrieval_time)) {
                    this.data_expired(retrieval_time, json_obj, key);
                    this.clear_store_key(key, type);
                }
            }
        }
        return response;
    },
    storage_retrieve: function (type, key) {
        var json_string;
        try {
            json_string = this.web_storage_stores[type].getItem(key);
        } catch (er) {
            console.warn(er);
        }
        if (json_string && typeof json_string === 'string') {
            try {
                var json_obj = JSON.parse(json_string);
                return json_obj;
            } catch (er) {
                console.warn(er);
            }
        }
        return json_string;

    },
    storage_store: function (in_key, in_value, type, options) {
        try {
            this.web_storage_stores[type].setItem(in_key, in_value);
            this.update_meta_info(in_key, type, options);
        } catch (er) {
            console.warn(er);
            return this.on_storage_error(er, in_key, in_value, type, options);
        }
        return true;
    },
    /**
     * 
     * @param {String} in_key
     * @param {String Object} in_value
     * @param {String} in_type
     * @param {Boolean} metadata - A flag for wether or not to store meta data. A value of true will not store meta data
     * @returns {undefined}
     */
    store: function (in_key, in_value, in_type, options) {
        if (!in_type) {
            in_type = this.get_meta_info_key_type(in_key);
        }
        var type = this.get_storage_type(in_type);
        if (in_value === null) {
            return this.clear_store_key(this.prepare_key(in_key), type);
        }
        if (this.storage_store(this.prepare_key(in_key), this.prepare_json_value(in_value, type, options), type, options)) {
            return true;
        } else {
            return false;
        }
    },
    update_meta_info: function (in_key, in_type, options) {
        var metainfo = this.get_meta_info();
        if (!options || !options.remove) {
            var dateObj = new OCS.Classes.OCSDateTime();
            var metadata;
            if (options && options.timestamp_epoch) {
                metadata = {t: options.timestamp_epoch};
            } else {
                metadata = {t: dateObj.get_server_epoch_time()};
            }
            metainfo[in_type][in_key] = metadata;
        } else {
            // Remove the key from the meta data
            if (metainfo[in_type] && metainfo[in_type][in_key]) {
                delete metainfo[in_type][in_key];
            }
        }
        this.web_storage_stores[this.options.meta_storage_type].setItem(this.options.meta_storage_key, metainfo);
    },

    /*
     * 
     * Event Fires
     * 
     */
    data_expired: function(test_time, json_obj, key) {
        this.fireEvent(this.options.data_expiration_event, {"data_time": parseInt(json_obj.t * this.options.time_resolution), "current_time": test_time, "data": this.get_value_from_json(json_obj), "key": key, "storage_manager": this});
    },

    /*
     * Event Listeners
     */
    on_clear_storage: function () {
        if (this.clear_storage_timeout) {
            clearTimeout(this.clear_storage_timeout);
            this.clear_storage_timeout = null;
        }        
        var keys = this.get_stored_keys();
        keys.each(function (key) {
            Object.each(this.web_storage_stores, function (store, store_name) {
                this.clear_store_key(key, store_name);
            }, this);
        }, this);

        this.deep_clean_storage();

    },
    on_storage_error: function (er, in_key, in_value, type, options) {
        this.web_storage_status[type] = false;
        if (this.isQuotaExceeded(er)) {
            console.debug('storage_manager: storage quota exceeded. Attempting to cleanup the problem.');
            //Clean up store and try again if possible
            this.cleanup_store(type, {deep_clean: true});
            if (this.web_storage_status[type] && this.storage_store(in_key, in_value, type, options)) {
                // Lets try again, but if we fail we stop trying on this
                return true;
            }
        }
        return false;
    },

    /*
     * Boolean Methods
     */
    check_web_storage_type: function (type) {
        if (type === this.options.js_storage_type_string) {
            return true;
        }
        try {
            if (type === this.options.local_storage_type_string && this.options.allow_local_storage) {
                return this.web_storage_test(window.localStorage, type);

            }
            if (type === this.options.session_storage_type_string && this.options.allow_session_storage) {
                return this.web_storage_test(window.sessionStorage, type);
            }
        } catch (e) {
            console.warn('storage_manager: Failed to pass test for ' + type + ' storage type. ', e);
        }
        return false;
    },
    data_key_exist: function (in_key, in_type) {
        var key = this.prepare_key(in_key);
        var type;
        if (!in_type) {
            type = this.get_meta_info_key_type(key);
        } else {
            type = in_type;
        }
        if (this.web_storage_stores[type] && this.web_storage_stores[type].getItem(key)) {
            return true;
        }
        if (!in_type) {
            if (this.data_key_exist(in_key, this.options.js_storage_type_string) || this.data_key_exist(in_key, this.options.local_storage_type_string) || this.data_key_exist(in_key, this.options.session_storage_type_string)) {
                // So we found it, just not where we thought, lets rebuild our metadata
                this.initialize_meta_info();
                return true;
            }
        }
        return false;
    },
    is_time_expired: function (product_time, type, query_time) {
        if (this.options.never_expire) {
            return false;
        }
        if ((product_time < (query_time - this.options.expiration_offset[type])) || (product_time > query_time)) {
            return true;
        } else {
            return false;
        }
    },
    isQuotaExceeded: function (e) {
        var quotaExceeded = false;
        if (e) {
            if (e.code) {
                switch (e.code) {
                    case 22:
                        quotaExceeded = true;
                        break;
                    case 1014:
                        // Firefox
                        if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            quotaExceeded = true;
                        }
                        break;
                }
            } else if (e.number === -2147024882) {
                // Internet Explorer 8
                quotaExceeded = true;
            }
        }
        return quotaExceeded;
    },
    web_storage_test: function (webStorage, type) {
        var json_string = this.prepare_json_value(this.options.storage_test_obj);
        var key = this.prepare_key(this.options.storage_test_key);
        try {
            var test_obj = webStorage.getItem(key);
            if (!test_obj) {
                // Test that we can write
                webStorage.setItem(key, json_string);
                test_obj = webStorage.getItem(key);
            }
            if (test_obj) {
                // Remove it
                webStorage.setItem(key, null);
                webStorage.removeItem(key);

                // We successfully written, it passes the test
                return true;
            }

        } catch (e) {
            console.warn('storage_manager: Failed to pass test for ' + type + ' storage type. ', e);
            // Access denied :-( fallback to js storage;
        }
        return false;
    },
    /*
     * Get / Set Methods
     */
    get_meta_info: function () {
        var meta_info = this.storage_retrieve(this.options.js_storage_type_string, this.options.meta_storage_key);
        if (!meta_info) {
            meta_info = this.initialize_meta_info();
        }
        return meta_info;
    },
    get_meta_info_key_type: function (in_key, in_type) {
        var type = this.get_storage_type(in_type);
        var metainfo = this.get_meta_info();
        if (in_type) {
            // We have a first guess to try
            if (metainfo && metainfo[in_type] && metainfo[in_type][in_key]) {
                return in_type;
            }
            // Didn't find it in our metainfo, lets see if its there anyways
            if (this.web_storage_stores[in_type] && this.web_storage_stores[in_type].getItem(this.prepare_key(in_key))) {
                this.initialize_meta_info();
                return in_type;
            }

        }

        if (metainfo) {
            Object.each(metainfo, function (values, key) {
                if (values[in_key]) {
                    type = key;
                }
            }.bind(this));
        }
        return type;
    },
    get_storage_type: function (type) {
        if (!type) {
            type = this.options.default_storage_type;
        }
        if (this.web_storage_status[type]) {
            return type;
        } else {
            if (type === this.options.local_storage_type_string && this.web_storage_status[this.options.session_storage_type_string]) {
                return this.options.session_storage_type_string;
            }
            return this.options.js_storage_type_string;
        }
    },
    get_stored_keys: function () {
        var meta_info = this.get_meta_info();
        var stored_keys = [];
        Object.each(meta_info, function (values, key) {
            stored_keys.combine(Object.keys(values));
        }.bind(this));
        return stored_keys;
    },
    get_value_from_json: function (obj) {
        if (obj && obj.hasOwnProperty('v')) {
            return obj.v;
        }
    },
    set_debug: function (val) {
        this.options.debug = val;
    },
    /*
     * Destroy Methods
     */
    destroy: function () {
        if (this.clear_storage_timeout) {
            this.on_clear_storage();
        }
        if (this.options.debug) {
            console.debug('Storage Manager: Destroying!');
        }
        this.removeEvents();
        this.web_storage_stores = {};
        this.web_storage_status = {};
        OCS.Live[this.manager_name] = null;
        delete OCS.Live[this.manager_name];
    }
});

